<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto py-[3.75vw] bg-white">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          蓝悦教育荣誉
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          西工大，陕师大等技术团队支持，定时课程更新，拥有多项运营资质和大赛成果
        </div>
      </div>
    </div>

    <!-- 证件区域 -->
    <div
      class="relative w-[61.46vw] h-auto left-1/2 -translate-x-1/2 inline-flex justify-center items-center gap-[1.04vw]"
    >
      <div
        v-for="(item, index) in honorList"
        :key="index"
        class="w-auto inline-flex flex-col justify-start gap-[0.52vw]"
      >
        <el-image
          class="w-[14.58vw] h-[9.95vw] outline outline-1 outline-offset-[-0.50px] outline-[#eaeaea]"
          :src="item.image"
          lazy
          alt="图片"
        />
        <div
          class="w-[14.58vw] h-auto py-[0.42vw] justify-center text-center text-[#1a2233] text-[0.83vw] font-normal font-harmony"
        >
          {{ item.text }}
        </div>
      </div>
    </div>

    <!-- 获奖区域 -->
    <div
      class="relative w-[61.46vw] h-auto mt-[2.08vw] left-1/2 -translate-x-1/2 flex flex-col justify-between items-center gap-[1.25vw]"
    >
      <!-- <div
        class="justify-center text-center text-[#1a2233] text-[1.04vw] font-harmony font-bold"
      >
        大赛证书
      </div> -->
      <div
        class="relative w-[61.46vw] h-auto inline-flex justify-between items-center gap-[1.04vw]"
      >
        <div
          v-for="(item, index) in awardList"
          :key="index"
          class="w-auto inline-flex justify-between gap-[0.52vw]"
        >
          <el-image
            class="w-[14.58vw] h-[9.95vw] outline outline-1 outline-offset-[-0.50px] outline-[#eaeaea]"
            :src="item.image"
            lazy
            alt="图片"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "abouotus-module4",
  data() {
    const images = require.context(
      "@/assets/images/AboutUs/module4",
      false,
      /^\.\/image\d+\.png$/ // 匹配 image1.png、image2.png 等图片
    );

    return {
      honorList: [
        {
          image: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/aboutus/module4/sample2.png`,
          text: "ASFC裁判证书",
        },
        {
          image: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/aboutus/module4/sample3.png`,
          text: "ASFC裁判证书",
        },
        {
          image: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/aboutus/module4/sample4.png`,
          text: "民用无人驾驶航空器运营合格证",
        },
      ],
      awardList: images.keys().map((imgPath) => ({
        image: images(imgPath),
      })),
    };
  },
};
</script>

<style scoped>
</style>